import React from 'react';
import styled from 'astroturf/react';
import pluralize from 'pluralize';
import { LikesMenu } from 'js/social/UserListMenu/LikesMenu';
import { NewsType, ResourceType, asEnum } from 'js/social/shared/types';
import _Container from "Stats-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Stats.tsx?styleId=Container";
import _Likes from "Stats-Likes.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Stats.tsx?styleId=Likes";
import _Comments from "Stats-Comments.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/News/Stats.tsx?styleId=Comments";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Likes = /*#__PURE__*/styled("button", null, {
  displayName: "Likes",
  styles: _Likes
});

const Comments = /*#__PURE__*/styled("button", null, {
  displayName: "Comments",
  styles: _Comments
});

interface Props {
  newsId: number | string;
  newsType: NewsType;
  numLikes: number;
  numComments: number;
  className?: string;
  toggleCommentSection: () => void;
}

const Stats: React.FunctionComponent<Props> = ({
  newsId,
  newsType,
  numLikes,
  numComments,
  className,
  toggleCommentSection,
}) => {
  const likesText = `${numLikes} ${pluralize('like', numLikes)}`;
  const likesSection = numLikes > 0 ? <span>{likesText}</span> : null;
  const commentsSection =
    numComments > 0
      ? `${numComments} ${pluralize('comment', numComments)}`
      : null;

  return (
    <Container className={className}>
      {likesSection && (
        <LikesMenu
          resourceId={newsId}
          resourceType={asEnum(ResourceType, newsType)}
        >
          <Likes>{likesSection}</Likes>
        </LikesMenu>
      )}
      {commentsSection && (
        <Comments onClick={toggleCommentSection}>
          <span>{commentsSection}</span>
        </Comments>
      )}
    </Container>
  );
};

export default Stats;
